import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';

// 重定向至"中天网页版"！
// if (window.location.pathname.indexOf("mobile") === -1){
//   window.location.replace("https://w3.zto.com");
// }



unregister();
ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js